import { useCallback } from 'react';

import { Sorting } from 'types';

import { useQueryData } from './use-query-data.hook';
import { useQueryPagination } from './use-query-pagination.hook';

export function useQuerySorting(initialData?: Partial<Sorting>) {
  const { data, initialized, setData, reset } = useQueryData<Sorting>(
    'sorting',
    initialData,
  );

  const { resetPagination } = useQueryPagination();

  const handleSortingUpdate = useCallback(
    (data: Sorting) => {
      resetPagination();
      setData(data);
    },
    [resetPagination, setData],
  );

  const handleSortingReset = useCallback(() => {
    resetPagination();
    reset();
  }, [reset, resetPagination]);

  return {
    sorting: data,
    initialized,
    setSorting: handleSortingUpdate,
    resetSorting: handleSortingReset,
  };
}
